import React, { useState, useContext, useEffect, useReducer } from "react"
import styled from "styled-components"
import { navigate } from "gatsby"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import jioMoneyImg from "../../../static/images/bank/1.png"
import googlePayImg from "../../../static/images/bank/2.png"
import phonePeImg from "../../../static/images/bank/3.png"
import upiImg from "../../../static/images/bank/4.png"
import bhimImg from "../../../static/images/bank/5.jpg"
import walletImg from "../../../static/images/bank/6.jpg"
import paytmImg from "../../../static/images/bank/7.png"
import buddyImg from "../../../static/images/bank/9.png"
import MobiKwikImg from "../../../static/images/bank/10.png"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { DataLayerIntegration,
 
  findCurrentJourneyCode,
  getValueFromLookup,
  mapReceiptEnquiryToPaymentStatus,
  isPostRFITransaction,
  isPostRfiReceiptSuccess,
  buildPostRFIDecryptData,
  applyPostRFIPaymentOutcomeSections,
} from "../services/helperFunctions"
import { fetchAllJourneyData, paymentText, saveApplication, saveTransactionDetails ,checkPaymentStatus, checkPaymentStatusEnquiry, paymentTextDecrypt, updateProductDetails, fetchApplicationDetails, getTOFpaymentReceipt, generateBI, sendEmailBI, getConfigurationsByType, saveBasbaTransactionLogs, ifscCodeDetails, postRfiReceipt } from "../../services/apiservice"
import { calculateAge } from "../../shared/functions"
import base64 from "base-64"
import * as lookup from "../../../static/lookup.json"
import Select from "react-select"
import { Link } from "gatsby"
import { applyComma, lineCapital } from '../../shared/functions'
import { errorToastr, successToastr } from "../../services/error-handler"
// const chequeChannels=["A","PBP","C","30","31","32","SPECTRUM"];//hsbc pbp canara robinhood/oneinsure MIBL MAIBRO Spectrum
// const SIChannelsHide=["30","31","32"];//robinhood/oneinsure MIBL MAIBRO

 const RadioContainer = styled.div`
    width: 100%;
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      z-index: 999;
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      & > .radio-label {
        text-align: center;
      }
    }

    .card {
      width: 100%;
      padding:1rem0;
      border-radius: 1rem;
      border-radius: 15px;
      background-color: #fff;
      position: relative;
      margin: 0px;
      margin-bottom: 0px;
      cursor: pointer;
      height: 9rem;
      max-height:max-content
      margin-top: 0px;
      box-shadow: 0px 0px 20px #ccc;
      transition: all 200ms;

      .amount {
        display:flex;
        align-items:center;
        justify-content:center;
        color: black;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ededed;
        color: black;
        text-align: center;
        padding-right: 34px;
      }
    }

    /*Check tick start  */
    .checked {
      background: #ededed;
      color: #ededed;
      position: absolute;
      left: 1rem;
      top: 1rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      padding: 8px;
      & > * {
        font-size: 1.2rem;
      }
    }

    input:checked ~ .card .checked {
      background: #fff;
      color: ${props =>
            props.channel === "A"
                ? "#3e505d"
                : props.channel === "B"
                    ? "#a20a3a"
                    : props.channel === "C"
                        ? "#0ab0ef"
                        : "#eb7f25"};
      color: var(--lumiq-card-bg);
    }
    /*Check tick end */

    .icon-container {
      font-size: 3rem;
      padding: 1rem;
      span {
        border-radius: 50%;
        padding: 1rem;

        background: #3e505d;
        .hero-icon {
          padding-top: 8px;
          color: #fff;
        }
      }
    }

    input:checked ~ .card {
      background-color: ${props =>
            props.channel === "A"
                ? "#3e505d"
                : props.channel === "B"
                    ? "#a20a3a"
                    : props.channel === "C"
                        ? "#0ab0ef"
                        : "#eb7f25"};
      background-color: var(--lumiq-card-bg);
      color: #fff;
      .icon-container-1 {
        span {
          background: #fff;
          .hero-icon {
            color: #3e505d;
          }
        }
      }

      .amount {
        display:flex;
        align-items:center;
        justify-content:center;
        color: white;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ffffff;
        color:black
        text-align: center;
        padding-right: 34px;
      }
    }

    input:not(:checked) ~ .card {
      /* opacity: 0.5; */
      .amount {
        color: #818181;
      }

      .desc {
        color: #3e505d;
      }
    }

    @media screen and (max-width: 767px) {
  .option-buit-design-new-structure-selected .row > div {
    width: 100% !important;
    margin-bottom: 15px;
  }
  
  .provider {
    min-width: auto;
    width: 100%;
  }
  
  .card {
    width: 100%;
  }
}
    `

let options1 = [
  {
    value: "bankAccountNumber",
    label: "Bank Account Number",
    minMaxLength: "12",
    type: "text"
  },
  {
    value: "hsbc",
    label: "HSBC Customer ID",
    minMaxLength: "9",
    type: "text"
  },
  {
    value: "debit",
    label: "Debit Card Number",
    minMaxLength: "16",
    type: "password"
  },
  {
    value: "credit",
    label: "Credit Card Number",
    minMaxLength: "16",
    type: "password"
  },
]


let options = options1.map((el) => ({
  value: el.value,
  label: el.label,
  minMaxLength: el.minMaxLength
}))

const InputContainer1 = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > input {
  }
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background-color: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    min-height: 2rem;
  }
`

const DateContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .form-control {
    box-shadow: 0 0 0 30px ${props => props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"} inset !important;
    box-shadow: 0 0 0 30px var(--lumiq-secondary) inset !important;
    color: white;
  }

  & > .date-input {
    display: flex;
    position: relative;
    border: 1px solid #929292;
    padding-right: 6px;
    input {
      width: 100%;
      border: none;
      outline: none;
      z-index: 5;
      background: transparent;

      &::-webkit-calendar-picker-indicator {
        color: rgba(0, 0, 0, 0);
        opacity: 0;
        cursor: pointer;
      }
    }

    .input-icon {
      position: absolute;
      right: 1rem;
      cursor: pointer;
      bottom: -5px;
      & > * {
        color: ${props => props.channel === "A" ? "#db0011" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#fec32b" : "#eb7f25"};
        color: var(--lumiq-tertiary);
      }
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    color: white;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
`

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 18px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"}  !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 1rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1.3rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;        

    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

const SelectContainer1 = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > select {
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background-color: var(--lumiq-bg);

    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .form-control {
    box-shadow: 0 0 0 30px ${props => props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"} inset !important;
    box-shadow: 0 0 0 30px var(--lumiq-secondary) inset !important;
    color: white;
  }

  & > input {
  }
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: white;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background-color: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    min-height: 2rem;
  }
`

const payOptions = [
  { key: "cheque", value: "Cheque" },
  { key: "dd", value: "DD" },
  { key: "credit", value: "Credit Card" },
  { key: "debit", value: "Debit Card" },
  { key: "net", value: "Net Banking" },
  { key: "upi", value: "UPI" },
  { key: "wallets", value: "Wallets" },
]
const initialRfiState = {
  accountNo: "",
  ifscCode: "",
  accountType: null,
  errors: {
    accountNo: "",
    ifscCode: "",
    accountType: ""
  }
};

function rfiReducer(state, action) {
  switch (action.type) {
    case "SET_FIELD":
      return {
        ...state,
        [action.field]: action.value,
        errors: {
          ...state.errors,
          [action.field]: ""
        }
      };
    case "SET_ERROR":
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.field]: action.error
        }
      };
    case "SET_ERRORS":
      return {
        ...state,
        errors: action.errors
      };
    case "RESET":
      return initialRfiState;
    default:
      return state;
  }
}

export default function Payment(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [allJourneyData, setAllJourneyData] = useState({})
  const [proceedWithOption, setProceedWithOption] = useState()

  const [dropDown, setDropDown] = useState("bankAccountNumber");
  const [minMaxLength, setMinMaxLength] = useState("12");
  const [showError, setShowError] = useState(false)
  const [bankAccountNumVal, setBankAccountNumVal] = useState();
  const [type, setType] = useState("text");
  const [errorMsg, setErrorMsg] = useState("Please enter Bank Account Number");
  const [label, setLabel] = useState("Bank Account Number");
  const [paymentTermsCond2, setPaymentTermsCond2] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [skipPayment, setSkipPayment] = useState(false)
  const [isBasbaAttempted, setIsBasbaAttempted] = useState("N")
  const [biApiData, setBiApiData] = useState(null)
  const [paymentModule, setPaymentModule] = useState("si")
  const [isULIP,setIsULIP]=useState(false);
  const [paymentOption, setPaymentOption] = useState("cheque")
  const [chequeChannels, setChequeChannels] = useState([]);
  const [SIChannels, setSIChannels] = useState([]);
  const [basbaChannels, setBasbaChannels] = useState([]);
  const [postRFIChannels, setPostRFIChannels] = useState([]);
  
  // RFI Bank Details State
  const [rfiState, rfiDispatch] = useReducer(rfiReducer, initialRfiState);
  const rfiSectionRef = React.useRef(null);



  const navigatePostRFIOutcome = (rfiRes, isSuccess) => {
    const decryptDataObj = buildPostRFIDecryptData(rfiRes, isSuccess)
    const { journeySteps: updatedSteps, targetSectionIndex } = applyPostRFIPaymentOutcomeSections(
      journeyState.journeySteps,
      isSuccess
    )
    setJourneyState(prev => ({
      ...prev,
      journeySteps: updatedSteps,
      paymentDecryptData: decryptDataObj,
    }))
    props.setCurrentSectionIndex(targetSectionIndex)
  }

  const handleRfiAccountNoChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 20)
    rfiDispatch({ type: "SET_FIELD", field: "accountNo", value })
  }

  const handleIfscChange = async (e) => {
    let value = e.target.value.toUpperCase();
    if (value.length > 11) {
      value = value.slice(0, 11);
    }
    rfiDispatch({ type: "SET_FIELD", field: "ifscCode", value });

    if (value.length === 11) {
      const regex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
      if (!regex.test(value)) {
        rfiDispatch({ type: "SET_ERROR", field: "ifscCode", error: "Invalid IFSC Code format" });
        return;
      }
      try {
        const res = await ifscCodeDetails({ "MIR-BNK-IFSC-CD": value });
        if (res?.data && (res?.data?.allUniqueBankName || res?.data?.uniqueBankName)) {
          rfiDispatch({ type: "SET_ERROR", field: "ifscCode", error: "" });
        } else {
          rfiDispatch({ type: "SET_ERROR", field: "ifscCode", error: "IFSC Code not found" });
        }
      } catch (err) {
        console.info("error in ifscCodeDetails", err)
        rfiDispatch({ type: "SET_ERROR", field: "ifscCode", error: "Error validating IFSC Code" });
      }
    }
  };


  
  // AGE mismatch
  const [showModalAge, setShowModalAge] = useState(false)
  const [ageDiff, setAgeDiff] = useState(false)

  // GST cutoff mismatch
  const [showModalGST, setShowModalGST] = useState(false)
  const [gstConfig, setGstConfig] = useState(null)

  // Product mismatch
  const [showModalProduct, setShowModalProduct] = useState(false)
  const [productConfig, setProductConfig] = useState(null)
  

  // //To skip paymentPage if payment is done already
  // useEffect(() => {
  //   if(journeyState.paymentDecryptData?.status === "Success"){
  //     props.setCurrentPageIndex(prev => prev + 1)
  //   }
  // }, [])
  

    useEffect(()=>{
    const action=async () => {
    if (biApiData && journeyState.applicationNo) {
      try {
        const res = await getTOFpaymentReceipt(journeyState.applicationNo)
        const receipts = res.data || [];
        const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
        let sum = 0;
        validReceipts.forEach(receipt => {
          sum += parseInt(receipt.amount);
        });
        if (sum >= (Math.round(biApiData?.[0]?.[isULIP?"MODAL_PREM_DISP":"MODAL_PREM_TAX"]))) {
          setSkipPayment(true);
        }
        setJourneyState(prev => ({
          ...prev,
          receipts: validReceipts
        }));

      } catch (error) {
        console.error(error)
      }
    }
  }
  action()
  }, [biApiData, journeyState.applicationNo])


  useEffect(() => {
    const checkBIValidity = async () => {
      // 1. Age mismatch check
      if (allJourneyData?.ageAtBI) {
        const currentAge = calculateAge(allJourneyData?.lifeAssuredDetails?.dob)
        if (Number(currentAge) !== Number(allJourneyData?.ageAtBI)) {
          setShowModalAge(true)
          setAgeDiff(true)
          return
        }
      }

      // 2. GST cutoff check
      if (allJourneyData?.productDetails?.biGeneratedAt) {
        try {
          const gstConfig = await getConfigurationsByType({
            type: "gst-config",
          })
          const cutOffTime = Number(gstConfig.data?.[0]?.config?.cutOffTime)
          setGstConfig(gstConfig.data?.[0]?.config)
          if (
            cutOffTime &&
            Number(allJourneyData.productDetails.biGeneratedAt) < cutOffTime
          ) {
            setShowModalGST(true)
            return
          }else{
            console.info(cutOffTime,allJourneyData.productDetails.biGeneratedAt, "s")
          }
        } catch (err) {
          console.info("error in fetching gst config", err)
        }
      }

      // 3. ProductId mismatch check
      if (allJourneyData?.productDetails?.productId) {
        try {
          const currentProductId = journeyState?.productId

          if (
            currentProductId &&
            currentProductId !== allJourneyData.productDetails.productId
          ) {
            // fetch product-config
            const productIdConfig = await getConfigurationsByType({
              type: "product-id-config",
            })

            setProductConfig(productIdConfig.data?.[0]?.config)
            setShowModalProduct(true)
            return
          }
        } catch (err) {
          console.info("error in fetching product config", err)
        }
      }
    }

    checkBIValidity()
  }, [
    allJourneyData?.ageAtBI,
    allJourneyData?.productDetails?.biGeneratedAt,
    allJourneyData?.productDetails?.productId,
    journeyState.productId
  ])

  useEffect(()=>{
    const action =async () => {
    if (journeyState.journeyId) {
      let payload = {
        journeyId: journeyState.journeyId,
        // journeyId: "60f6e6f6e53b33e1e6299223",
      }

      // Call both APIs in parallel
      const [journeyResult, configResult] = await Promise.all([
        fetchAllJourneyData(payload),
        getConfigurationsByType({ type: "payment-config" })
      ]);

      journeyResult.isBasbaAttempted="Y";
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
      setAllJourneyData(journeyResult);
      setBiApiData(journeyResult.productDetails.BIJson?JSON.parse(journeyResult.productDetails.BIJson):null)
      // Set channels from config API response
      if (configResult?.data) {
        setChequeChannels(configResult.data?.[0].config?.products?.[journeyState.journeyIdFromStrapi]?.chequeChannels || []);
        setSIChannels(configResult.data?.[0].config?.products?.[journeyState.journeyIdFromStrapi]?.siChannels || []);
        setBasbaChannels(configResult.data?.[0].config?.products?.[journeyState.journeyIdFromStrapi]?.basbaChannels || []);
        setPostRFIChannels(configResult.data?.[0].config?.products?.[journeyState.journeyIdFromStrapi]?.postRFIChannels || []);
      }
      if(["alphaWealthPlanJourney","titaniumPlusJourney","Promise4GrowthPlusJourney"].includes(journeyState.journeyIdFromStrapi)){
        setIsULIP(true);
      }
      let lastTransaction = journeyResult?.transactionDetails?.transactions?.[journeyResult?.transactionDetails?.transactions.length - 1]
      if (isPostRFITransaction(lastTransaction)) {
        setPaymentModule("postRFI")
      }
      if (!lastTransaction || (lastTransaction?.status !== "Success")){
        const exisitingPlanCode = journeyResult?.productDetails?.planOption
        if (!lookup.paymentPagePlanOption[0].hasOwnProperty(exisitingPlanCode)){
          setShowModal(true)
          return;
        }
      }

      if (journeyResult.hasOwnProperty("transactionDetails")) {
        if (journeyResult.transactionDetails.paymentStatus !== 'Aborted') {
          props.setCurrentSectionIndex(prev => prev + 1)
        }
      }
      
    }
  }
  action()
  }, [journeyState.journeyId])

  const handlePayNow = () => { 
        if (!paymentTermsCond2) {
          return;
        }
        if (journeyState.channel.toLowerCase() === "a") {
          if (!bankAccountNumVal) {
            setShowError(true);
            setErrorMsg(`Please enter ${label}`)
            return;
          } else {
            if (bankAccountNumVal?.length < minMaxLength) {
              setShowError(true);
              setErrorMsg(`Please enter ${minMaxLength} Digits ${label}`)
              return;
            }
          }
        }

        let temp = journeyState.journeySteps
        // let pageShowWithTransactionStatus = temp.pages[props.currentPageIndex].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
        // let tempSectionIndex = pageShowWithTransactionStatus.findIndex(handlesection => section.sectionId === "unsuccessful-transaction")
        //
        let sendPayload = {
          applicationData: journeyState.journeyData,
          journeyData: {
            _id: journeyState.journeyId,
            lastPage: props.currentPageIndex,
            lastSection: 1,//because after filtering out for other sections this will be the index of unsuccessful-transaction
            applicationNo: journeyState.applicationNo,
            illustrationNumber: journeyState.illustrationNumber,
            proposalEntryId: journeyState.proposalEntryId,
            premium: journeyState.premium,
            lastPageCode: props.pageId,
            paymentStep: journeyState.paymentStep,
            lastSectionCode: "unsuccessful-transaction",
            planOption: journeyState.planOption,
            isBasbaAttempted:'N',
            "basicDetails.hsbcBankRelationshipId": dropDown !== "hsbc" ? bankAccountNumVal : "",
            "basicDetails.hsbcCustomerId": dropDown === "hsbc" ? bankAccountNumVal : "",
            "basicDetails.hsbcRelationshipType": dropDown
          },
        }
        saveApplication(sendPayload).then(res => {
          console.log(res, "application response")
          console.log(allJourneyData, "allJourneyDta")
          const paymentPayload = {
            journeyId: journeyState.journeyId,
            module: paymentModule
          }
     
          paymentText(paymentPayload)
            .then(res => {
              console.log(res)
              let abortTransactionPayload = {
                journeyId: journeyState.journeyId,
                applicationNumber: journeyState.applicationNo,
                status: 'Aborted',
                srcTraceId: res.data.payload.srcTraceId,
                amount: res.data.payload.amount,
                paymentTxnId: 0,
                source: 'ISNP',
                paymentTxnDate: res.data.payload.applicationLaunchDate,
                paymentType:paymentModule
              }
              console.log(abortTransactionPayload, "abortTransactionPayload")
              saveTransactionDetails(abortTransactionPayload).then((result) => {
                if (paymentModule === "postRFI") {
                  const rfiPayload = {
                    journeyId: journeyState.journeyId,
                    srcTraceId: abortTransactionPayload.srcTraceId,
                    rfiDetails: {
                      accountNo: rfiState.accountNo,
                      ifscCode: rfiState.ifscCode,
                      accountType: rfiState.accountType?.value || "-1" //-1 to indicate some error
                    }
                  }
                  postRfiReceipt(rfiPayload)
                    .then(rfiRes => {
                      navigatePostRFIOutcome(rfiRes, isPostRfiReceiptSuccess(rfiRes))
                    })
                    .catch(err => {
                      console.info(err, "postRfiReceipt error response")
                      navigatePostRFIOutcome({ data: { errMsg: err?.message } }, false)
                    })
                }
                else{
                  console.log(result, "saveSrcTraceIdForAbortTransactionCase")
                  const redirectUrlPayload = {
                    applicationNumber: journeyState.applicationNo,
                    journeyId: journeyState.journeyId,
                    source: journeyState.channel,
                    module: paymentModule,
                  }
                  console.log(redirectUrlPayload, "redirectUrlPayload")
                  const data = JSON.stringify(redirectUrlPayload)
                  var encodedStringBtoA = btoa(data)
                  let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
                  if (`${process.env.DEVELOPMENT}` === "Y") {//for si call enach url whereas for cheque call normal url
                    const url = `${paymentModule==="si"?process.env.ENACH_URL:process.env.PAYMENT_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/payment-redirection/`; 
                    window.open(url, "_self");
                  }
                  else if (`${process.env.DEVELOPMENT}` === "N") {
                    const url = `${paymentModule==="si"?process.env.ENACH_URL:process.env.PAYMENT_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/${productKey}/payment-redirection/`;
                    window.open(url, "_self");
                  }
                }
                })
     
              // props.setCurrentSectionIndex(prev => prev + 1)
              // setJourneyState(prev => {
              //   return {
              //     ...prev,
              //     lastPage: props.currentPageIndex,
              //     lastSection: props.currentSectionIndex,
              //     lastPageCode: props.pageId,
              //     lastSectionCode:
              //       props.sections[props.currentSectionIndex].sectionId,
              //     journeyCode: findCurrentJourneyCode(
              //       props.pageId,
              //       props.sections[props.currentSectionIndex].sectionId
              //     ),
              //   }
              // })
            })
            .catch(error => {
              console.error(error)
            })
        }).catch(err => {
          console.error(err, "err in saveApplication")
        })
        }
      
  const checkandPayNow = async () => {
    if (paymentModule === "postRFI") {
      let hasError = false;
      const errors = { accountNo: "", ifscCode: "", accountType: "" };

      if (!rfiState.accountNo) {
        errors.accountNo = "Account Number is required";
        hasError = true;
      } else if (!/^\d{1,20}$/.test(rfiState.accountNo)) {
        errors.accountNo = "Account Number must contain only numbers (max 20 digits)";
        hasError = true;
      }
      if (!rfiState.ifscCode) {
        errors.ifscCode = "IFSC Code is required";
        hasError = true;
      } else {
        const regex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
        if (!regex.test(rfiState.ifscCode)) {
          errors.ifscCode = "Invalid IFSC Code format";
          hasError = true;
        }
      }
      if (!rfiState.accountType) {
        errors.accountType = "Account Type is required";
        hasError = true;
      }

      rfiDispatch({ type: "SET_ERRORS", errors });

      if (hasError) {
        errorToastr("Please fill all required RFI Bank Details correctly.");
        if (rfiSectionRef.current) {
          rfiSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      try {
        const res = await ifscCodeDetails({ "MIR-BNK-IFSC-CD": rfiState.ifscCode });
        if (!res?.data || (!res?.data?.allUniqueBankName && !res?.data?.uniqueBankName)) {
          rfiDispatch({ type: "SET_ERROR", field: "ifscCode", error: "IFSC Code not found" });
          errorToastr("Invalid IFSC Code. Please check and try again.");
          if (rfiSectionRef.current) {
            rfiSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }
      } catch (err) {
        rfiDispatch({ type: "SET_ERROR", field: "ifscCode", error: "Error validating IFSC Code" });
        errorToastr("Error validating IFSC Code. Please try again.");
        if (rfiSectionRef.current) {
          rfiSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }
    }

    if (journeyState.journeyId) {
      let payload = {
        journeyId: journeyState.journeyId,
      }
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "proceed", journeyState)
      // for fetching latest transaction details
      let journeyResult = await fetchAllJourneyData(payload)
      if (journeyResult?.transactionDetails) {
        let lastTransaction = journeyResult?.transactionDetails?.transactions?.[journeyResult?.transactionDetails?.transactions.length - 1]
        // last transation success then navigate to resume journey
        if (lastTransaction && (lastTransaction?.status === "Success")) {
          // errorToastr("Unauthorized Payment")
          navigate(`/unauthorized-transaction` ,{ state: {applicationNumber: journeyState.applicationNo} })
        }
        else {
          const isPostRFIPayment = isPostRFITransaction(lastTransaction)
          const handleResolvedPaymentStatus = (newPaymentStatus, applicationNumber) => {
            lastTransaction.status = newPaymentStatus
            const payloadForSaveTransaction = {
              journeyId: journeyState.journeyId,
              paymentType: lastTransaction?.paymentType || paymentModule,
              ...lastTransaction
            }
            console.log(payloadForSaveTransaction, "payloadForSaveTransaction")
            saveTransactionDetails(payloadForSaveTransaction).then((resp) => {
              console.log(resp, "saveTransactionDetails")
              if (newPaymentStatus === "Pending") {
                navigate(`/pending-transaction?applicationNumber=${applicationNumber}`, { state: { paymentStatus: "Pending", applicationNumber } })
              } else if (newPaymentStatus === "Success") {
                navigate(`/unauthorized-transaction`, { state: { applicationNumber: journeyState.applicationNo } })
              } else {
                handlePayNow()
              }
            }).catch(err => {
              console.log(err)
            })
          }

          if (isPostRFIPayment) {
            checkPaymentStatusEnquiry({ applicationNumber: journeyState.applicationNo }).then((statusRes) => {
              const newPaymentStatus = mapReceiptEnquiryToPaymentStatus(statusRes)
              const applicationNumber = journeyState.applicationNo
              handleResolvedPaymentStatus(newPaymentStatus, applicationNumber)
            }).catch(err => {
              console.log(err, "checkPaymentStatusEnquiry error")
              if (lastTransaction?.status === "Aborted") {
                handlePayNow()
              }
            })
          } else {
            checkPaymentStatus(journeyResult.transactionDetails.srcTraceId).then((res_str) => {
              const payload = {
                "encryptedtext": res_str
              }
              if (lastTransaction && lastTransaction?.status === "Aborted" && !res_str) {
                handlePayNow()
                return
              }
              paymentTextDecrypt(payload).then(res => {
                console.info(res, "paymentTextDecrypt")
                const newPaymentStatus = res.data.status
                handleResolvedPaymentStatus(newPaymentStatus, res.data.applicationNumber)
              }).catch(err => {
                console.log(err)
              })
            }).catch(err => {
              console.log(err)
            })
          }
        }
      }
      // no transaction details found then user proceed payment normally.
      else {
        handlePayNow()
      }
    }
  }
  const registerForBasba = async () => {
    if (!paymentTermsCond2){ // return if disclaimer is unchecked
      return;
    }
    let temp = journeyState.journeySteps;
    // let pageShowWithTransactionStatus = temp.pages[props.currentPageIndex].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") }) || [];
    // let tempSectionIndex = pageShowWithTransactionStatus.findIndex(section => section.sectionId === "pending-transaction-basba")//pending-transaction-basba 
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: journeyState.premium ,
        lastPageCode: props.pageId,
        lastSectionCode: "pending-transaction-basba",
        planOption: journeyState.planOption,
        isPhysicalMandateOpt: false,
        isBasbaAttempted:'Y'
      },
    }
    setJourneyState(prev => {
      return {
        ...prev,
        isPhysicalMandateOpt: false,
      }
    })
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      const paymentPayload = {
        journeyId: journeyState.journeyId,
        module: "basba"
      }
      paymentText(paymentPayload)
        .then(res => {
          const abortTransactionPayload = {
            amount: res.data.payload.amount,
            applicationNumber: journeyState.applicationNo,
            journeyId: journeyState.journeyId,
            mandateExecuteStatus: "",
            mandateStatus: "Aborted",
            mandateTxnId: "233917",
            receiptNo: "",
            source: "ISNP",
            srcTraceId: res.data.payload.srcTraceId,
            status: "Aborted",
            mandateTxnDate: res.data.payload.applicationLaunchDate,
          }
          saveBasbaTransactionLogs(abortTransactionPayload).then((response) => {
            const redirectUrlPayload = {
              applicationNumber: journeyState.applicationNo,
              journeyId: journeyState.journeyId,
              source: journeyState.channel,
              module: "basba",
            }
            console.log(redirectUrlPayload, "redirectUrlPayload")
            const data = JSON.stringify(redirectUrlPayload)
            var encodedStringBtoA = btoa(data)

            let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
            if (`${process.env.DEVELOPMENT}` === "Y") {
              const url = `${process.env.ENACH_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/lien-redirection/`;
              window.open(url, "_self");
            }
            else if (`${process.env.DEVELOPMENT}` === "N") {
              const url = `${process.env.ENACH_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/${productKey}/lien-redirection/`;
              window.open(url, "_self");
            }
          }).catch({})
        })
        .catch(error => {
          console.log(error)
        })
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const handleReCalculate = () => {
      let e = ""
      let formControlKey = "reCalculate"
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey, journeyState)
    
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)

      let tempPage
      if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageFlexiEdgeCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageTitaniumPlusCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "AlphaWealthPlanCalculateFundValuePage")
      } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedOnePayCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedIncomeAdvantageCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedSavingsCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageInsureSmartCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageJeevenNiveshCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageMoneyBackCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageInvest4GCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageSmartJuniorCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageSecureBhavishyaCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedFortuneCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedFutureCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedIncome4LifeCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "GAINcalculatePremiumPage")
      } else if (journeyState.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "Promise4GrowthPlusCalculateFundValuePage")
      } else {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageISelect360CalculatePremium")
      }
      let sectionsTokeep = tempPage.pageData.filter((section => {
        return !["iSelect360CPOptionalInBuilt", "iSelect360CPSpouseCoverDetails"].includes(section.sectionId)
      }))

      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: sectionsTokeep,
        }
      })
      let tempState
      if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionFlexiEdgeCalculatePremiumPersonalDetails")
      } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "CFSectionTitaniumPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "AlphaWealthPlanCFpersonelDetailsSection")
      } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGOPAPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedIncomeAdvantagePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedSavingsPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionInsureSmartPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionJeevanNiveshCalculatePremiumPersonalDetails")
      } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionMoneyBackPersonalDetails")
      } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionInvest4GPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionSmartJuniorPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionSecureBhavishyaPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedFortunePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedFuturePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedIncome4LifePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "GAINpersonalDetailsSection")
      } else if (journeyState.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "Promise4GrowthPlusCFpersonelDetailsSection")
      } else {
        tempState = tempPage.pageData.find(section => section.sectionId === "CPPersonalDetailsSection")
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }


  const handleDropDown = e => {
    setErrorMsg("");
    console.log(e);
    if (e?.value) {
      let el = options1.find(el => el.value == e.value)
      if (el) {
        setDropDown(el.value);
        setMinMaxLength(el.minMaxLength);
        setType(el.type);
        setLabel(el.label);
        setBankAccountNumVal("");
      }
    } else {
      setDropDown("");
    }
  }

  const bankAccountInput = e => {
    if (!isNaN(e.target.value)) {
      if (e.target.value.length == minMaxLength) {
        setShowError(false);
        setErrorMsg("");
      }
      if (e.target.value.length === 0) {
        setShowError(true);
        setErrorMsg(`Please enter ${label}`)
      } else {
        setShowError(false);
        setErrorMsg("");
      }
      setBankAccountNumVal(e.target.value);
    } else {
      return;
    }
  }
  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }

  function capitalize(str) {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1);
  }

  const openAccordion = (id, key) => {
    ;[
      "collapse0",
      "collapse1",
      "collapse2",
      "collapse3",
      "collapse4",
      "collapse5",
      "collapse6",
      "collapse7",
    ].forEach(el => {
      let accord = document.getElementById(el)
      if (accord && el !== id) {
        accord.classNameList.remove("in")
      }
    })
    let accordion = document.getElementById(id)
    if (accordion.classNameList.contains("in")) {
      accordion.classNameList.remove("in")
      setPaymentOption("")
    } else {
      accordion.classNameList.add("in")
      setPaymentOption(key)
    }
  }

   const handleBiRedirection = () => {
    const isProposer = allJourneyData?.lifeAssuredDetails.isLaAndPropSame === "N";
    let biSectionIndex = isProposer ? 6 : 3;

    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: 1,
        lastSection: biSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: journeyState.premium,
        lastPageCode: props.pageId,
        paymentStep: journeyState.paymentStep,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
      }
    };

    saveApplication(sendPayload)
      .catch(console.log)
      .finally(() => {
        props.setCurrentPageIndex(1);
        props.setCurrentSectionIndex(biSectionIndex);
        setShowModalAge(false);
        setShowModalGST(false);
        setShowModalProduct(false);
      });
  };

  const premiumFrequencyLookup = lookup["premiumFrequency"][0]
  const planOptionLookup = lookup["planOption"][0];
  const paymentPlanLookup= lookup["paymentPagePlanOption"][0];
  const productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
  const navigateToTermsAndCondition = () => {
    console.log(`${process.env.GATSBY_URL}/terms-and-condition/`);
    if (`${process.env.DEVELOPMENT}` === "Y") {
      window.open(`${process.env.GATSBY_URL}/terms-and-condition/`, 'popup', 'width=600,height=600');
    }
    else if (`${process.env.DEVELOPMENT}` === "N") {
      window.open(`${process.env.GATSBY_URL}/${productKey}/terms-and-condition/`, 'popup', 'width=600,height=600');
    }
  }

  const handleOnChange = (data) => {
    if (data === "paymentTermsCond2") {
      setPaymentTermsCond2(!paymentTermsCond2);
    }
  }
  const handlePayOption = ({ target }) => {
    switch (target.value) {
      case "si":
        setPaymentModule("si");
        setIsBasbaAttempted("N");
        rfiDispatch({ type: "RESET" });
        break;
      case "cheque":
        setPaymentModule("cheque");
        setIsBasbaAttempted("N");
        rfiDispatch({ type: "RESET" });
        break;
      case "basba":
        setPaymentModule("basba");
        setIsBasbaAttempted("Y");
        rfiDispatch({ type: "RESET" });
        break;
      case "postRFI":
        setPaymentModule("postRFI");
        setIsBasbaAttempted("N");
        setTimeout(() => {
          if (rfiSectionRef.current) {
            rfiSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
        break;
      default:
        break;
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "","make-Payment",target.value, journeyState)
  }

  const handleEnterPayoutOption = (event, value) => {
        console.log(event.key);
        if (event.key == 'Enter') {
            handlePayOption({ target: { value: value } })
        }

    }


  return (
    <>
      {/* checkbox css */}
      <style>
        {`/* The container */
      .checkbox-label {
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 2rem;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      /* Hide the browser's default checkbox */
      .checkbox-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      /* Create a custom checkbox */
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #ccc;
        border-radius:0;
      }

      /* On mouse-over, add a grey background color */
      .checkbox-label:hover input ~ .checkmark {
        background-color: #ccc;
      }

      /* When the checkbox is checked, add a theme background */
      .checkbox-label input:checked ~ .checkmark {
        background-color:  ${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"};
        background-color:  var(--lumiq-tertiary);
      };
      }

      /* Create the checkmark/indicator (hidden when not checked) */
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      /* Show the checkmark when checked */
      .checkbox-label input:checked ~ .checkmark:after {
        display: block;
      }

      /* Style the checkmark/indicator */
      .checkbox-label .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }`}
      </style>

      <style>
        {`
  
          .details-card-wrapper{
            width:80%;
            margin:0 auto

          }

          @media screen and (max-width:768px){
            .details-card-wrapper{
              width:98%;
            }
          }

          @media screen and (min-width:991px){
            .bankCSSFix{
              display:flex !important;
              flex-direction:row !important;
              margin-left: 120px !important;
              gap:3rem !important;
            }
          }
          @media screen and (max-width:990px){
            .bankCSSFix{
              display:flex !important;
              flex-direction: column !important;
            }
          }
          .details-card{      
              border-radius:10px;
              overflow:hidden;
              margin-bottom:1rem;
              border:1px solid ${journeyState.channel === "A" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};    
              border:1px solid var(--lumiq-secondary);
          }
          
          .details-card::last-child{
              margin-bottom:0;       
          }
          
          .header{
              background: ${journeyState.channel === "A" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
              background: var(--lumiq-secondary);
              color: #fff;
              padding:1rem;
              text-align:center;
          }
  
          .data{
              display:flex;
              justify-content:space-between;
              padding:1rem;
              color:black;
              margin:0 4rem;
          }

          .data:not(:last-child){
            border-bottom:1px solid black;
            }
  
          .disclosure > *{
              margin-bottom:1rem;
  
          }     
          
          .note{
              padding:3rem;
              background: ${journeyState.channel === "A" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
              background: var(--lumiq-secondary);
              color:white;
              border-radius:10px;
          }
          .note > *{
            font-style:italic;
          }

          .btn-actions{
              display:flex;
              justify-content:center;
              gap:2rem;
          }
          
          .payment-option{
          background: ${journeyState.channel === "A" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
            background: var(--lumiq-secondary);
            color:white;
            padding:2rem

          }
          
          .payment-form{
              display:flex;
              flex-direction:column
          }
          .left{
              padding-right:4rem;
              border-right:1px solid white;
              width:30rem;
          }

          .left > *:not(:last-child){
              margin-bottom:1rem;
          }

          .right{
              width:100%;
          }
          .payment-strip{
              min-height:5rem;
              display:flex;
              align-items:center;
              flex-wrap:wrap;
              padding:2rem 5rem;

              gap: 1.5rem 2rem;
              background:white;
              justify-content:space-around
          }

          .payment-strip > img{
              height:2rem;
              cursor:pointer
          }

          .payment-btn{
              color:white;
              border:1px solid white;
              padding:1.5rem;
              cursor:pointer;
              text-align:center;
              background:transparent;
            }
            .payment-btn.active{
              background: ${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"};
              background: var(--lumiq-tertiary);
            }
            .payment-btn > a {
                color:white;
                text-decoration:none
            }
            
          
            .re-calculate{
                border:1px solid white;
                margin-left:1rem;

            }

          .re-calculate >  *{
              color:white !important;
          }

        .medium-icon{
          min-height:3.5rem;
        }
        .text-left{text-align:left}
        .text-right{text-align:right}
        
        .custom-form-control{
          height : 52px !important;
        }
        @media screen and (min-width: 767px) {
          .payment-options > div{
              flex-grow:1;
              max-width:50%;
            }
          }

        .input-container2{
          margin : 15px 0px ;
          color: rgb(99, 99, 99) ;
          height: 60px;
        }
           .css-1uccc91-singleValue{
              font-size: 14px !important;
            }
              
              `}
      </style>
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                  <h1 className="iselect-heading">{isBasbaAttempted === "Y" ? "Create Lien" : "Make Payment"}</h1>
                  </div>
                  <div class="app-quatation mt hidden-desktop-screen">
                    <div class="application-design-number">Application Number: {journeyState.applicationNo}</div>
                  </div>
                </div>

                <div className="iselect-padding ">
                  <div className="col-md-12 col-xs-12 ">
                    <div className="details-card-wrapper">
                      <div className="details-card ">
                        <div
                          className="header"
                          style={{ background: `${journeyState.channel === "A" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}` }}
                        // style={{ background: "var(--lumiq-card-bg)" }}
                        >
                          <span>Payment Details</span>
                        </div>
                        <div className="listing-structure-design-payment">
                          <ul className="list-inline">
                            <li className="text-left">Name of the Product</li>
                            <li className="text-right">
                              {
                                paymentPlanLookup[
                                allJourneyData?.productDetails?.planOption
                                ]
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">
                              Premium Payment Term (years)
                            </li>
                            <li className="text-right">
                              {
                                capitalize(lookup["policyTerm"][0][allJourneyData?.productDetails
                                  ?.premiumPaymentTerm] || '1 year')
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">Base Sum Assured (₹)</li>
                            <li className="text-right">
                              {allJourneyData?.productDetails?.sumAssured || ""}
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">Premium Frequency</li>
                            <li className="text-right">
                              {
                                premiumFrequencyLookup[
                                  allJourneyData?.productDetails?.premiumFrequency
                                ] ? capitalize(premiumFrequencyLookup[
                                  allJourneyData?.productDetails?.premiumFrequency
                                ]) : ""
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">
                              Name of the Policy Owner
                            </li>
                            <li className="text-right">
                              {
                                allJourneyData?.lifeAssuredDetails?.fullName ?
                                  capitalize(allJourneyData?.lifeAssuredDetails?.fullName) : ""
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">
                              Total Installment Premium (₹)
                            </li>
                            <li className="text-right">
                             {(+journeyState?.premium)?.toLocaleString() || ''}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {journeyState.channel === "A" &&
                  <>
                     <div className="row" style={{
                      justifyContent : "center"
                     }}>
                      <div className="col-lg-4 col-md-12 col-12">
                        <SelectContainer channel={journeyState.channel} className={`input-container`} >
                          <label className="input-label" >
                            Bank Relationship ID
                            <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                              <div className="tool">i</div>
                              <span className="tooltiptext4" style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none", textAlign: "justify" }}>
                                This is required to validate that you are an existing customer of HSBC bank. Please provide either your account number or customer ID or debit/credit card number.
                              </span>
                            </span>
                          </label>
                          <Select
                            options={options}
                            name="Select"
                            key="Select"
                            id="InputSelect"
                            required={true}
                            value={getKeyByValue(options, dropDown)}
                            onChange={handleDropDown}

                          ></Select>
                        </SelectContainer>

                      </div>

                      <div className="col-lg-4 col-md-12 col-12" style={{
                    marginTop : "-7px",
                  }}>
                        <InputContainer1 channel={journeyState.channel} className="form-group">
                          <label className="input-label">
                            {dropDown == "bankAccountNumber"
                              ? "Enter your Bank Account Number"
                              : dropDown == "hsbc"
                                ? "Enter your HSBC Customer ID"
                                : dropDown == "debit"
                                  ? "Enter your Debit Card Number"
                                  : dropDown == "credit"
                                    ? "Enter your Credit Card Number"
                                    : ""}
                          </label>
                          <input
                            className="form-control custom-form-control"
                            type={type}
                            name="email"
                            value={bankAccountNumVal}
                            required={true}
                            autoComplete="new-password"
                            placeholder={
                              dropDown == "bankAccountNumber"
                                ? "Enter your Bank Account Number"
                                : dropDown == "hsbc"
                                  ? "Enter your HSBC Customer ID"
                                  : dropDown == "debit"
                                    ? "Enter your Debit Card Number"
                                    : dropDown == "credit"
                                      ? "Enter your Credit Card Number"
                                      : ""
                            }
                            maxlength={minMaxLength}
                            minLength={minMaxLength}
                            disabled={false}
                            id="selectAccount"
                            onChange={bankAccountInput}
                          ></input>
                          {showError ? (<span className="input-error">{errorMsg}</span>) : ""}
                        </InputContainer1>
                      </div>
                    </div>

                  </>
                }
                <div className="iselect-mg-bottom check-design">
                  <div className="col-md-12 col-xs-12">
                    <div className="transactionDetailsWrap del-agree">
                      <div className="detailContentWrap">
                        <div
                          className="row iAgree"
                          style={{ textAlign: "center" }}
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="iselect-padding">
                  {/* Desktop tabs */}
                  <div
                    className="payment-option "
                    style={{ background: `${journeyState.channel === "A" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}` }}
                  // style={{ background: "var(--lumiq-card-bg)" }}
                  >
                    {/* <h4>Choose Your Preferred Payment Option</h4> */}
                    <div className="payment-form">
                      {/* <div className="left">
                        {payOptions.map(payOption => {
                          return (
                            <div
                              className={`payment-btn ${
                                payOption.key == paymentOption ? "active" : ""
                              }`}
                              onClick={() => handlePaymentOption(payOption.key)}
                            >
                              <a>{payOption.value}</a>
                            </div>
                          )
                        })}
                      </div> */}
                      {isBasbaAttempted === "Y"
                        &&
                        (<div className="right">
                          {!["upi", "wallets"].includes(paymentOption) ? (
                            <>
                              <div
                                style={{
                                  textAlign: "center",
                                  margin: "2rem 0",
                                }}
                              >
                                <div
                                  className="row iAgree"
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <div className="form-group">
                                    <div className="inner-addon left-addon align-error" style={{ width: "67%", margin: "auto", alignItems: 'flex-start' }}>
                                      <div className="checkbox1">
                                        <input
                                          id="checkboxG7"
                                          className={`css-checkbox form-control`}
                                          type="checkbox"
                                          checked={paymentTermsCond2}
                                          onChange={(e) => handleOnChange("paymentTermsCond2")}
                                        />
                                        {['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ?
                                          (<label
                                            htmlFor="checkboxG7"
                                            className="css-label"
                                            style={{ color: "white", filter: "brightness(1)" }}
                                          >
                                            As per the IRDAI's directions, I hereby provide my express consent and authorise
                                            Canara HSBC Life Insurance Company Limited to block an amount as quoted in this proposal form (including applicable taxes),
                                            for the purpose of premium payment towards insurance. I agree and understand that this mandate shall be valid
                                            for a period of (i) 14 days from the date of premium block mandate or (ii) date of acceptance of this proposal,
                                            whichever is earlier and that the blocked amount will be utilised towards premium payment upon proposal acceptance.
                                            I further authorise Canara HSBC Life Insurance Company Limited to share information with the relevant entities for the purpose
                                            of blocking/releasing the premium amount
                                          </label>) :
                                          (<label className="websiteCheckmarkcontainer">
                                            <span style={{
                                              marginLeft: "15px"
                                            }}>As per the IRDAI's directions, I hereby provide my express consent and authorise Canara HSBC Life Insurance Company Limited
                                              to block an amount as quoted in this proposal form (including applicable taxes),
                                              for the purpose of premium payment towards insurance. I agree and understand that this mandate shall be valid
                                              for a period of (i) 14 days from the date of premium block mandate or (ii) date of acceptance of this proposal,
                                              whichever is earlier and that the blocked amount will be utilised towards premium payment upon proposal acceptance.
                                              I further authorise Canara HSBC Life Insurance Company Limited to share information with the relevant entities for the purpose
                                              of blocking/releasing the premium amount</span>
                                            <input type="checkbox" checked={paymentTermsCond2} onChange={(e) => handleOnChange("paymentTermsCond2")} />
                                            <span className="checkmarkWebsite" />
                                          </label>)}
                                      </div>
                                      {!paymentTermsCond2 && (<span className="input-error payment-error1" style={{ fontSize: '15px', marginLeft: "5.2rem", color:"#9a0000 !important"}}>
                                        This field is required
                                      </span>)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </>
                        ) : null}
                        <div
                          className="col-md-12"
                          style={{ paddingTop: "3rem" }}
                        >
                        </div>
                      </div>)} 
                      <div className="right">
                        {!["upi", "wallets"].includes(paymentOption) && isBasbaAttempted==="N" ? (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                margin: "2rem 0",
                              }}
                            >
                              <div
                                className="row iAgree"
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <div className="form-group">
                                  <div className="inner-addon left-addon align-error" style={{ width: "67%", margin: "auto", alignItems: 'flex-start' }}>
                                    <div className="checkbox1">
                                      <input
                                        id="checkboxG7"
                                        className={`css-checkbox form-control`}
                                        type="checkbox"
                                        checked={paymentTermsCond2}
                                        onChange={(e) => handleOnChange("paymentTermsCond2")}
                                      />
                                      {['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ?
                                        (<label
                                          htmlFor="checkboxG7"
                                          className="css-label"
                                          style={{ color: "white", filter: "brightness(1)" }}
                                        >
                                          I accept all terms &amp; conditions and hereby declare that premium shall be paid by Proposer.
                                        </label>) :
                                        (<label className="websiteCheckmarkcontainer">
                                          <span style={{
                                            marginLeft: "15px"
                                          }}>I accept all terms &amp; conditions and hereby declare that premium shall be
                                            paid by Proposer.</span>
                                          <input type="checkbox" checked={paymentTermsCond2} onChange={(e) => handleOnChange("paymentTermsCond2")} />
                                          <span className="checkmarkWebsite" />
                                        </label>)}
                                    </div>
                                    {!paymentTermsCond2 && (<span className="input-error payment-error1" style={{ fontSize: '15px', marginLeft: "5.2rem", color:"#9a0000 !important" }}>
                                      This field is required
                                    </span>)}
                                  </div>
                                </div>
                              </div>
                              <p>
                                If your age changes during the period your
                                insurance proposal is under consideration with
                                the company, then the premium as per your
                                attained age will apply and you will be required
                                to pay the additional amount for issuing the
                                policy.
                              </p>
                            </div>
                          </>
                        ) : null}
                        <div
                          className="col-md-12"
                          style={{ paddingTop: "3rem" }}
                        >
                          <div className="but-center text-center">
                            <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                              <div className="col-md-12">
                                <div className="option-buit-design-new-structure-box">
                                  {allJourneyData?.journeyType !== "CanaraPos" && !skipPayment && (() => {
                                    const ch = props?.channel?.toUpperCase();
                                    const prem = Number(Math.round(biApiData?.[0]?.[isULIP ? "MODAL_PREM_DISP" : "MODAL_PREM_TAX"]));
                                    const showSI     = SIChannels.includes(ch);
                                    const showCheque = chequeChannels.includes(ch);
                                    const showBasba  = allJourneyData?.journeyType !== "CanaraPos" && basbaChannels.includes(ch) && prem <= 500000;
                                    const showRFI    = postRFIChannels.includes(ch);
                                    const count = [showSI, showCheque, showBasba, showRFI].filter(Boolean).length;
                                    const colClass = count >= 4 ? "col-lg-6 col-md-12 col-sm-12 col-xs-12" : "col-lg-4 col-md-12 col-sm-12 col-xs-12";
                                    return (
                                    <div className="option-buit-design-new-structure-selected">
                                      <div className="row payment-options" style={{justifyContent:"center"}}>
                                        {showSI && <div className={colClass}>
                                          <RadioContainer>
                                            <div
                                              style={{ borderRadius: "15px" }}
                                              className="provider"
                                              tabIndex="0"
                                            >
                                              <label className="width">
                                                <input
                                                  type="radio"
                                                  name="pay"
                                                  value="si"
                                                  hidden
                                                  onChange={handlePayOption}
                                                  checked={
                                                    isBasbaAttempted==="N" && paymentModule === "si"
                                                  }
                                                />
                                                <div className="card justify-content-center" >
                                                  <div className="checked">
                                                    <svg
                                                      stroke="currentColor"
                                                      fill="currentColor"
                                                      stroke-width="0"
                                                      viewBox="0 0 512 512"
                                                      height="1em"
                                                      width="1em"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                      <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                                    </svg>
                                                  </div>
                                                  <div className="amount">
                                                    <span>
                                                      Advance SI
                                                    </span>
                                                  </div>
                                                  <div className="desc">
                                                    <span>
                                                      Pay your{" "}
                                                      {lineCapital(
                                                        getValueFromLookup(
                                                          "biFrequencyLabel",
                                                          allJourneyData?.productDetails
                                                            ?.premiumFrequency
                                                        ) ?? ""
                                                      ) || "NA"}{" "}
                                                      Premium{" "}
                                                        <b>
                                                          {biApiData ? `₹ ${applyComma(Math.round(biApiData?.[0]?.[isULIP ? "MODAL_PREM_DISP" : "MODAL_PREM_TAX"]))}` : "NA"}{" "}
                                                        </b>
                                                      now and proceed.
                                                    </span>
                                                  </div>
                                                </div>
                                              </label>
                                            </div>
                                          </RadioContainer>
                                        </div>}

                                        {showCheque && <div className={colClass}>
                                          <RadioContainer>
                                            <div
                                              style={{ borderRadius: "15px" }}
                                              className="provider"
                                              tabIndex="0"
                                            >
                                              <label className="width">
                                                <input
                                                  type="radio"
                                                  name="pay"
                                                  value="cheque"
                                                  hidden
                                                  onChange={handlePayOption}
                                                  checked={
                                                    isBasbaAttempted==="N" && paymentModule === "cheque"
                                                  }
                                                />
                                                <div className="card justify-content-center">
                                                  <div className="checked">
                                                    <svg
                                                      stroke="currentColor"
                                                      fill="currentColor"
                                                      stroke-width="0"
                                                      viewBox="0 0 512 512"
                                                      height="1em"
                                                      width="1em"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                      <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                                    </svg>
                                                  </div>
                                                  <div className="amount">
                                                    <span>
                                                      Cheque 2.0
                                                    </span>
                                                    <div></div>
                                                  </div>
                                                  <div className="desc">
                                                      <span>
                                                        Continue with your application and
                                                        pay
                                                        <b>
                                                          {biApiData ? ` ₹ ${applyComma(Math.round(biApiData?.[0]?.[isULIP ? "MODAL_PREM_DISP" : "MODAL_PREM_TAX"]))}` : "NA"}{" "}
                                                        </b>
                                                      </span>
                                                  </div>
                                                </div>
                                              </label>
                                            </div>
                                          </RadioContainer>
                                        </div>}

                                        {showBasba &&
                                          <div className={colClass}>
                                            <RadioContainer>
                                              <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0" onKeyPress={(event) => handleEnterPayoutOption(event, "basba")}>
                                                <label className="width">
                                                  <input
                                                    type="radio"
                                                    name="pay"
                                                    value="basba"
                                                    hidden
                                                    checked={isBasbaAttempted === "Y" ? true : false}
                                                    onChange={handlePayOption}
                                                  />
                                                  <div className="card justify-content-center">
                                                    <div className="checked">
                                                      <FaCheck />
                                                    </div>
                                                    <div className="amount">
                                                      <span>
                                                        UPI 2.0 (BASBA)
                                                      </span>
                                                    </div>

                                                    <div className="desc">
                                                      <span>
                                                        Continue with blocking
                                                        <b>
                                                          {biApiData ? ` ₹ ${applyComma(Math.round(biApiData?.[0]?.[isULIP?"MODAL_PREM_DISP":"MODAL_PREM_TAX"]))}` : "NA"}
                                                        </b>{" "}
                                                        by opting UPI 2.0
                                                      </span>
                                                    </div>
                                                  </div>
                                                </label>
                                              </div>
                                            </RadioContainer>
                                          </div>
                                        }

                                        {showRFI &&
                                          <div className={colClass}>
                                            <RadioContainer>
                                              <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0" onKeyPress={(event) => handleEnterPayoutOption(event, "postRFI")}>
                                                <label className="width">
                                                  <input
                                                    type="radio"
                                                    name="pay"
                                                    value="postRFI"
                                                    hidden
                                                    onChange={handlePayOption}
                                                    checked={isBasbaAttempted === "N" && paymentModule === "postRFI"}
                                                  />
                                                  <div className="card justify-content-center">
                                                    <div className="checked">
                                                      <FaCheck />
                                                    </div>
                                                    <div className="amount">
                                                      <span>
                                                        Payment Post RFI
                                                      </span>
                                                    </div>
                                                    <div className="desc">
                                                        <span>
                                                          Continue with your application and pay{" "}
                                                          <b>
                                                            {biApiData ? `₹ ${applyComma(Math.round(biApiData?.[0]?.[isULIP ? "MODAL_PREM_DISP" : "MODAL_PREM_TAX"]))} ` : "NA"}{" "}
                                                          </b>
                                                          post RFI.
                                                        </span>
                                                    </div>
                                                  </div>
                                                </label>
                                              </div>
                                            </RadioContainer>
                                          </div>
                                        }

                                      </div>
                                    </div>
                                    );
                                  })()}
                                </div>
                                {skipPayment && <p style={{
                                  textAlign: "center",
                                  fontSize: "18px",
                                  marginTop: "30px"

                                }}>Premium of Rs {`${biApiData ? applyComma(Math.round(biApiData?.[0]?.[isULIP?"MODAL_PREM_DISP":"MODAL_PREM_TAX"])) : "NA"}`} is adjusted against transfer of funds from old application</p>}
                              </div>
                            </div>
                            {isBasbaAttempted === "N" ?
                              <input
                                type="submit"
                                className="provider previous-btn cen pay-now hidden-desktop-screen"
                                tabIndex="0"
                                onMouseOver={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = '#404040'
                                    e.target.style.border = '1px solid #404040'
                                  }
                                }}
                                onFocus={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = '#404040'
                                    e.target.style.border = '1px solid #404040'
                                  }
                                }}
                                onMouseOut={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                      ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                      : journeyState.channel?.toLowerCase() == 'd'
                                        ? '#cc6c1d'
                                        : `${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    e.target.style.border = '1px solid white'
                                  }
                                }}
                                onBlur={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                      ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                      : journeyState.channel?.toLowerCase() == 'd'
                                        ? '#cc6c1d'
                                        : `${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    e.target.style.border = '1px solid white'
                                  }
                                }}
                                style={{
                                  color: "white",
                                  padding: "14px 40px",
                                  border: ['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ? "none" : "1px solid white",
                                  marginLeft: "8px",
                                  background: journeyState.channel?.toLowerCase() == 'b'
                                    ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-secondary2)
                                    : journeyState.channel?.toLowerCase() == 'd'
                                      ? '#cc6c1d'
                                      : `${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-tertiary)
                                }}
                                value="Submit"
                                onClick={checkandPayNow}
                              /> :
                              <input
                                type="submit"
                                className="provider previous-btn cen pay-now hidden-desktop-screen"
                                tabIndex="0"
                                onMouseOver={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = '#404040'
                                    e.target.style.border = '1px solid #404040'
                                  }
                                }}
                                onFocus={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = '#404040'
                                    e.target.style.border = '1px solid #404040'
                                  }
                                }}
                                onMouseOut={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                      ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                      : journeyState.channel?.toLowerCase() == 'd'
                                        ? '#cc6c1d'
                                        : `${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    e.target.style.border = '1px solid white'
                                  }
                                }}
                                onBlur={(e) => {
                                  if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                    e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                      ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                      : journeyState.channel?.toLowerCase() == 'd'
                                        ? '#cc6c1d'
                                        : `${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    e.target.style.border = '1px solid white'
                                  }
                                }}
                                style={{
                                  color: "white",
                                  padding: "14px 40px",
                                  border: ['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ? "none" : "1px solid white",
                                  marginLeft: "8px",
                                  background: journeyState.channel?.toLowerCase() == 'b'
                                    ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-secondary2)
                                    : journeyState.channel?.toLowerCase() == 'd'
                                      ? '#cc6c1d'
                                      : `${journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-tertiary)
                                }}
                                value="Register Now"
                                onClick={registerForBasba}
                              />
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {paymentModule === "postRFI" && (
                  <div className="iselect-padding">
                    <div ref={rfiSectionRef} className="rfi-bank-details-wrapper" style={{ marginTop: "20px", marginBottom: "25px", padding: "20px", border: "1px solid #e0e0e0", borderRadius: "15px", background: "#ffffff", boxShadow: "0px 0px 20px #ccc", width: "100%", float: "none", display: "block" }}>
                      <h3 style={{ fontSize: "18px", marginBottom: "20px", color: `${journeyState.channel === "A" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}`, fontWeight: "bold", textAlign: "left" }}>RFI Bank Details</h3>
                      <div className="row">
                        <div className="col-lg-4 col-md-12 col-12">
                          <InputContainer1 channel={journeyState.channel} className="form-group" style={{ width: "100%", float: "none" }}>
                            <label className="input-label" style={{ color: "#505050", minHeight:"auto" }}>Account Number</label>
                            <input
                              type="text"
                              inputMode="numeric"
                              maxLength={20}
                              className="form-control custom-form-control"
                              placeholder="Enter Account Number (max 20 digits)"
                              value={rfiState.accountNo}
                              style={{ border: "1px solid #929292", borderRadius: "0px" }}
                              onChange={handleRfiAccountNoChange}
                            />
                            {rfiState.errors.accountNo && <span className="input-error" style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>{rfiState.errors.accountNo}</span>}
                          </InputContainer1>
                        </div>

                        <div className="col-lg-4 col-md-12 col-12">
                          <InputContainer1 channel={journeyState.channel} className="form-group" style={{ width: "100%", float: "none" }}>
                            <label className="input-label" style={{ color: "#505050" , minHeight:"auto"}}>IFSC Code</label>
                            <input
                              type="text"
                              className="form-control custom-form-control"
                              placeholder="Enter IFSC Code"
                              value={rfiState.ifscCode}
                              style={{ border: "1px solid #929292", borderRadius: "0px" }}
                              onChange={handleIfscChange}
                            />
                            {rfiState.errors.ifscCode && <span className="input-error" style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>{rfiState.errors.ifscCode}</span>}
                          </InputContainer1>
                        </div>

                        <div className="col-lg-4 col-md-12 col-12">
                          <SelectContainer channel={journeyState.channel} className="input-container2" style={{ float: "none", minWidth: "100%" }}>
                            <label className="input-label" style={{ color: "#505050", marginBottom: "5px", minHeight:"auto" }}>Account Type</label>
                            <Select
                              options={Object.entries(lookup.accountTypeForProposer[0] || {}).map(([key, val]) => ({
                                value: key,
                                label: val
                              }))}
                              value={rfiState.accountType}
                              onChange={(selectedOption) => {
                                rfiDispatch({ type: "SET_FIELD", field: "accountType", value: selectedOption });
                              }}
                              placeholder="Select Account Type"
                            />
                            {rfiState.errors.accountType && <span className="input-error" style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>{rfiState.errors.accountType}</span>}
                          </SelectContainer>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="iselect-padding">
                  <h2 style={{ fontSize: "16px" }}  >Guide: </h2>
                  <ul className="disclosure">
                    <li>
                      You may need to go for a medical examination to complete
                      the application process. Our representative will be in
                      touch with you for any additional information or document
                      or medical test that may be required to assess your
                      insurance proposal.
                    </li>
                    <li>
                      We will need the documents like age proof, address proof,
                      photograph, ID proof and income proof to process your
                      application. You can email, upload or courier the
                      documents after making the premium payment.
                    </li>
                    <li>
                      {" "}
                      The policy will be issued on the basis of the information
                      given by you in this application form.
                    </li>
                    <li>
                      Insurance is a contract of utmost good faith, requiring
                      the Life to be Assured and the Insurer to disclose all
                      material facts. If there is any doubt in response to
                      whether any fact is material, it should be disclosed.
                      Failure to do so may invalidate the contract based on this
                      form.
                    </li>
                    <li>
                      Kindly note that any non-disclosure or misrepresentation
                      or suppression of information with respect to you has a
                      direct impact on the claim decision. It may even lead to
                      repudiation of the claim.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              {isBasbaAttempted === "Y" ?
                <div className="submit-btn cen" aria-hidden="true" onClick={registerForBasba}>
                  Register Now
                </div>
                :
                <div className="submit-btn cen" aria-hidden="true" onClick={checkandPayNow}>
                Submit
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button-->  */}
      {showModal && (
        <>
          <div style={{
            position : "fixed",
            top : 0,
            left : 0,
            width : "100%",
            height : "100%",
            opacity : 0.5,
            background : "#000",
            zIndex : 1000
          }}>
          </div>
          <div style={{ position: "fixed", top: "40%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(255, 255, 255)", padding: "20px", border: "3px solid #0088c3", borderRadius: "8px", width: "80%", maxWidth: "600px", zIndex: 9999 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h4 style={{ textAlign:"center" , color: "#005575", margin: 0, flex: "1" }}>Benefit Illustration Regeneration</h4>
            </div>
            <p style={{textAlign:"center", fontSize:"15px"}} >Dear Customer, Premium rates for this product is revised as per IRDA guidelines. Request you to regenerate Benfit Illustration</p>
            <button onClick={() => {
              const isProposer = allJourneyData?.lifeAssuredDetails.isLaAndPropSame === "N";
              
              let biSectionIndex
              if (isProposer){  
                biSectionIndex = 6
              }else{  
                biSectionIndex = 3
              }
              let updatePayload = {
                journeyIdFromStrapi : journeyState.journeyIdFromStrapi,
                journeyId : journeyState.journeyId,
                existingPlanCode : allJourneyData?.productDetails?.planOption
              }
              updateProductDetails(updatePayload)
              .then(() => {
                let sendPayload = { 
                  applicationData: journeyState.journeyData,
                  journeyData: {
                    _id: journeyState.journeyId,
                    lastPage: 1,
                    lastSection: biSectionIndex,
                    applicationNo: journeyState.applicationNo,
                    illustrationNumber: journeyState.illustrationNumber,
                    proposalEntryId: journeyState.proposalEntryId,
                    premium: journeyState.premium,
                    lastPageCode: props.pageId,
                    paymentStep: journeyState.paymentStep,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                    planOption: journeyState.planOption,
                  },
                }
                saveApplication(sendPayload).then(console.log)
                .catch(console.log)
                .finally(() => {
                  props.setCurrentPageIndex(1)
                  props.setCurrentSectionIndex(biSectionIndex)
                  setShowModal(false)
                })
              })
              .catch(console.log)  
            }} style={{ backgroundColor: "#fec32b", color: "#fff", padding: "8px 16px", border: "none", borderRadius: "4px", cursor: "pointer", display: "block", margin: "0 auto" }}>Ok</button>
          </div>
        </>
  )}
    {(showModalAge && ageDiff) && (
    <ModalWrapper>
      <ModalContent
        title="Benefit Illustration Regeneration"
        message="Age is changed from login Date. Please regenerate the BI to proceed further"
        onOk={handleBiRedirection}
      />
    </ModalWrapper>
  )}

  {showModalGST && (
    <ModalWrapper>
      <ModalContent
        title={gstConfig.modalTitle || "Benefit Illustration Regeneration"}
        message={gstConfig.modalContent || "Dear Customer, Your Benefit Illustration is generated before GST cutoff date. Request you to regenerate Benefit Illustration."}
        onOk={handleBiRedirection}
      />
    </ModalWrapper>
  )}

  {showModalProduct && (
    <ModalWrapper>
      <ModalContent
        title={productConfig?.modalTitle || "Benefit Illustration Expired"}
        message={
          productConfig?.modalContent ||
          "Dear Customer, Your Benefit Illustration is generated for old product Id. Request you to regenerate Benefit Illustration."
        }
        onOk={handleBiRedirection}
      />
    </ModalWrapper>
  )}
    </>
  )
}




function ModalWrapper({ children }) {
  return (
    <>
      <div style={{
        position : "fixed",
        top : 0,
        left : 0,
        width : "100%",
        height : "100%",
        opacity : 0.5,
        background : "#000",
        zIndex : 1000
      }} />
      {children}
    </>
  );
}

function ModalContent({ title, message, onOk }) {
  return (
    <div style={{
      position: "fixed",
      top: "40%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      padding: "20px",
      border: "3px solid #0088c3",
      borderRadius: "8px",
      width: "80%",
      maxWidth: "600px",
      zIndex: 9999
    }}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
        <h4 style={{ textAlign:"center" , color: "#005575", margin: 0 }}>{title}</h4>
      </div>
      <p style={{ textAlign:"center", fontSize:"15px" }}>{message}</p>
      <button 
        onClick={onOk}
        style={{
          backgroundColor: "#fec32b",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          display: "block",
          margin: "0 auto"
        }}
      >
        Ok
      </button>
    </div>
  );
}